module.exports = __webpack_public_path__ + "static/media/debit-note.b51937e5.svg";